module.exports = __webpack_public_path__ + "img/lucky_mining.c9c6068c.png";